<template>
    <div>
        <van-card
            :tag="product.comment"
            centered>
            <div slot="thumb"><img src="@/assets/cloud.png" style="width:90px;height:90px"/></div>
            <div slot="title" style="font-size:18px">{{product.title}}</div>
            <div slot="desc">云盘大小：<span style="color:red;font-size:18px;padding-right:2px;">{{product.desc}}</span>GB</div>
            <div slot="price">￥<span style="font-size:14px;">{{product.price}}</span>/年</div>
            <div slot="origin-price">￥<span style="font-size:14px;">{{product.originPrice}}</span>/年</div>
        </van-card>
    </div>
</template>
<script>
import { fetchProduct } from '@/api/product'
export default {
  name: 'vipProduct',
  data () {
    return {
      product: { tag: '', price: '0.00', originPrice: '0.00', thumb: '', title: '', desc: '', isHot: false, comment: '' }
    }
  },
  created () {
    const id = this.$route.query.id
    // console.log(id)
    var that = this
    fetchProduct({ id: id }).then(res => {
      that.product.title = res.dataSource.name
      that.product.desc = res.dataSource.productDesc
      that.product.price = res.dataSource.price
      that.product.originPrice = res.dataSource.originPrice
      that.product.isHot = res.dataSource.isHot
      that.product.comment = res.dataSource.comment
      // console.log(that.product)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
